/**
 * Open a URL in a new tab while preserving authentication.
 *
 * sessionStorage is per-tab, so the new tab won't have the auth token.
 * This mirrors the legacy auth.js approach: stash the token in
 * localStorage briefly so the new tab's getStoredToken() can pick it up
 * within a 10-second window.
 */
export function openInNewTab(url: string): void {
  const token = sessionStorage.getItem('token');
  if (token) {
    localStorage.setItem('temp_token_for_new_tab', token);
    localStorage.setItem('temp_token_timestamp', String(Date.now()));
  }
  window.open(url, '_blank');
}
